import Lenis from "@studio-freight/lenis";

let lenis: Lenis | null = null;

/**
 * Initializes Lenis and starts the smooth scroll animation loop.
 */
export const initSmoothScroll = () => {
  if (typeof window !== "undefined" && !lenis) {
    lenis = new Lenis({
      duration: 1.5, // Duration of smooth scroll
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Custom easing
    });

    const raf = (time: number) => {
      lenis?.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }
};

/**
 * Smoothly scrolls to a specific target position or element.
 * @param target Target position (number) or element (HTMLElement)
 */
export const scrollTo = (target: number | HTMLElement) => {
  lenis?.scrollTo(target);
};
/**
 * Smoothly scrolls to an element by ID.
 * @param id The ID of the element to scroll to (e.g., "#services").
 */
export const scrollToId = (id: string) => {
  if (!id.startsWith("#")) {
    return;
  }

  const element = document.querySelector(id) as HTMLElement;
  if (element) {
    scrollTo(element);
  }
};
/**
 * Disables smooth scrolling.
 */
export const disableScrolling = () => {
  document.body.style.overflow = "hidden"; // Disable scrolling

  lenis?.stop();
};

/**
 * Enables smooth scrolling.
 */
export const enableScrolling = () => {
  lenis?.start();
  document.body.style.overflow = ""; // Disable scrolling
};
